module.exports = __webpack_public_path__ + "static/headsup-2973efbd34f6886a53a9538ff39e14b7.png";